import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Pagination from '../Layout/pagination';
import Paper from '@material-ui/core/Paper';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';

import DialogContent from '@material-ui/core/DialogContent';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';

import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';

import {
    ToggleOffOutlined as ToggleOffOutlinedIcon
} from '@material-ui/icons';

import {
    PersonOffOutlined as PersonOffOutlinedIcon,
    PersonOutlineOutlined as PersonOutlineOutlinedIcon
} from '@mui/icons-material';
import Switch from '@mui/material/Switch';
import { alpha, styled } from '@mui/material/styles';
import Tooltip from '@material-ui/core/Tooltip'

const GreenSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#F57922',
        '&:hover': {
            backgroundColor: alpha('#F57922', theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#FABC90',
    },
    '& .MuiSwitch-switchBase': {
        color: '#9FA1A4',
        '&:hover': {
            backgroundColor: alpha('#9FA1A4', theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase + .MuiSwitch-track': {
        backgroundColor: '#E4E6E8',
    },

}));

const styles = theme => ({
    papper: {
        minWidth: '300px',
    },
    rootDialog: {
        zIndex: 1505,
    },
    rootContent: {
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        boxShadow: '-5px 4px 10px #8E8E8E29',
        borderRadius: '21px',
        opacity: 1,
        maxWidth: '850px',
        minWidth: '290px',
        padding: '0px !important',
        overflow: 'hidden',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
})

const ItemUsuario = (props) => {
    /**
     * nombre : titulo del item
     * descripcion: sub titulo, una linea
     * fecha: seguna linea de sub titulo, timestamp
     * monto: cantidad a la derecha, formateada como moneda
     * opciones: lista de opciones desplegables {nombre: string, handler: func}
     * onClick: click en cualquier lugar del item
     */
    return <div onClick={props.onClick} className='containerItemUsuario' id='containerItemUsuario'>

        <div style={{ display: 'flex' }}>
            {(props.imagen !== undefined) &&
                <img alt="" src={props.imagen} className='imgUsuario' id='imagenUsuario' />}

            <div className='containerDatos' id='datosUsuario'>
                {<div className='labelNombre' id='nombreUsuario'>{props.nombre}</div>}
                <div className='labelDescripcion' id='descripcionUsuario'>{props.descripcion}</div>
                {(props.descripcion2 !== undefined) && <div className='labelDescripcion' id='descripcion2Usuario'>{props.descripcion2}</div>}
                {(props.descripcion3 !== undefined) && <div className='labelDescripcion descripcion3' id='descripcion3Usuario'>{props.descripcion3}</div>}
            </div>
            {(props.opciones !== undefined) &&
                <div onClick={(e) => { e.stopPropagation(); this.props.handleOnCalcularCantIconos(this.props.activo, this.props.listaNegra, this.props.listaBlanca) }} className='iconMenu' id='menuIconosUsuario'>
                    <Col>
                        <Row style={{
                            marginLeft: (props.cantIconos === 3) ? '-25px' :
                                (props.cantIconos === 2) ? '-10px' :
                                    (props.cantIconos === 1) ? '5px' :
                                        '0px'
                        }}>


                            {(props.activo !== true) && <Col className='iconContainer' id='iconoInactivoUsuario'><Tooltip title="Usuario inactivo" placement="top"><ToggleOffOutlinedIcon className='icon_inactive' /></Tooltip></Col>}
                            {(props.listaNegra === true) && <Col style={{ marginRight: "5px" }} className='iconContainer' id='iconoListaNegraUsuario'><Tooltip title="Usuario en lista negra" placement="top"><PersonOffOutlinedIcon className='icon_BlackList' /></Tooltip></Col>}
                            {(props.listaBlanca === true) && <Col className='iconContainer' id='iconoListaBlancaUsuario'><Tooltip title="Usuario en lista blanca" placement="top"><PersonOutlineOutlinedIcon className='icon_WhiteList' /></Tooltip></Col>}
                        </Row>
                        <PopupState variant="popover" popupId={"nuevo-usuario-menu"} id='popupStateMenuUsuario'>
                            {popupState => (
                                <React.Fragment>
                                    <IconButton {...bindTrigger(popupState)} id='iconoMenuUsuario'>
                                        <MoreVertIcon />
                                    </IconButton>
                                    <Menu {...bindMenu(popupState)} id='menuOpcionesUsuario'>
                                        {
                                            props.opciones.map((x, index) => { return x !== undefined ? <MenuItem key={index} onClick={(...args) => { x.handler(...args); popupState.close(...args) }} id={`opcion-${index}`}>{x.nombre}</MenuItem> : undefined })
                                        }
                                    </Menu>
                                </React.Fragment>
                            )}
                        </PopupState>
                    </Col>
                </div>}
        </div>
        {(props.habilitado !== true) && <div className='labelEstado' id='estadoUsuario'>{"Inhabilitado"}</div>}
        {/*{(props.activo !== true) && <div className='labelEstado' id='estadoInactivoUsuario'>{"Inactivo"}</div>}*/}

    </div>

}

class UsuarioListado extends React.Component {

    render() {

        const { classes } = this.props;

        return (
            <div>

                {/* menú superior */}
                <TitleBar
                    title='Usuarios'
                    searchPlaceholder='Ingrese usuario'
                    newButtonLink='/Usuarios/Edit/0'
                    showSearch={true}
                    handleOnSearch={this.props.handleOnSearch}
                    handleOnSearchAdvanced={this.props.handleOnAvanzado}
                    cantFiltros={this.props.cantFiltros}
                />


                <Paper style={{ backgroundColor: "transparent", boxShadow: 'none' }}>
                    <div >
                        <Row>
                            {this.props.usuarios.result && this.props.usuarios.result.map((x, i) =>
                                <Col sm={12} md={6} lg={4} style={{ margin: '5px 0px' }}>
                                    <ItemUsuario {...this.props.mapToItem(x)} />
                                </Col>)}
                        </Row>
                    </div>
                    <Pagination handleOnChange={this.props.handleOnPagination} page={this.props.usuarios.currentPage + 1 || 0} totalPages={this.props.usuarios.totalObjects !== 0 ? this.props.usuarios.totalPages : 0} />
                </Paper>

                {/** confirmacion */}
                <Dialog
                    classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootContent }}
                    id="ecommerce"
                    disableBackdropClick={true}
                    fullWidth={true}
                    maxWidth={'sm'}
                    open={this.props.openModalConfirm}
                    onClose={this.props.handleOnCloseConfirmacion}>
                    <div className='containerModalConfirmacion'>
                        <div className='labelModalConfirmacion'>{this.props.mensajeConfirmacion}</div>
                        <div className='containerBtnConfirmacion'>
                            <Button style={{ marginRight: "12px" }} className="btnSecundario" onClick={this.props.handleOnCloseConfirmacion} >Cancelar</Button>
                            {
                                (this.props.botonOk.map) ?
                                    this.props.botonOk.map((x, i) =>
                                        <Button variant="contained" className="btnPrincipalAux btnPrincipal btnPrincipalAuxMargin" onClick={() => { this.props.handleOk[i](); this.props.handleOnCloseConfirmacion(); window.setTimeout(() => { this.props.handleOnPagination(this.props.usuarios.currentPage + 1 || 0); }, 700) }}>{this.props.botonOk[i]}</Button>
                                    )
                                    : <Button variant="contained" className="btnPrincipalAux btnPrincipal" onClick={() => { this.props.handleOk(); this.props.handleOnCloseConfirmacion(); window.setTimeout(() => { this.props.handleOnPagination(this.props.usuarios.currentPage + 1 || 0); }, 700) }}>{this.props.botonOk}</Button>
                            }
                        </div>
                    </div>
                </Dialog>

                {/**Filtros adicionales */}
                <Dialog
                    id="ecommerce"
                    disableBackdropClick={true}
                    fullWidth={true}
                    maxWidth={'sm'}
                    open={this.props.openModal}
                    onClose={this.props.handleOnCloseModal}
                    classes={{ paperWidthSm: classes.papper }}
                >

                    <Grid container justify="space-between" alignItems="center">
                        <h2 className='titleBusquedaAvanzada'>Búsqueda avanzada </h2>
                        <IconButton className='iconButton'>
                            <CloseIcon onClick={this.props.handleOnCloseAvanzado} />
                        </IconButton>
                    </Grid>

                    <h2 className='lineaDivisionArriba'></h2>

                    <div style={{ width: "100%", padding: "30px" }}>
                        <Grid container spacing={24}>

                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth
                                    select
                                    value={this.props.tipoUsuario || undefined}
                                    onChange={this.props.handleOnChangeFiltro}
                                    input={<Input name="tipoUsuario" id="tipodeusuario-label" />}
                                    InputLabelProps={
                                        { shrink: this.props.tipoUsuario !== null, style: { marginLeft: "10px" } }
                                    }
                                    InputProps={{ className: "inputProps_TipoDeUsuario_Estado" }}
                                    displayEmpty
                                    label="Tipo de usuario"
                                    name="tipoUsuario">
                                    {(this.props.tiposUsuario && this.props.tiposUsuario.map) ?
                                        this.props.tiposUsuario.map((x) => (<MenuItem value={x.id}>{x.name}</MenuItem>))
                                        : undefined}</TextField>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField InputProps={{ className: "inputProps_Usuario_NombreApellido" }} fullWidth label={"Usuario"}
                                    InputLabelProps={
                                        { style: { marginLeft: "10px" } }
                                    }
                                    onChange={this.props.handleOnChangeFiltro} name="nombre" value={this.props.nombre} id="usuario-label" />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth
                                    select
                                    value={this.props.estado}
                                    onChange={this.props.handleOnChangeFiltro}
                                    input={<Input name="estado" id="tipodeusuario-label" />}
                                    InputLabelProps={
                                        { shrink: this.props.estado !== null, style: { marginLeft: "10px" } }
                                    }
                                    InputProps={{ className: "inputProps_TipoDeUsuario_Estado" }}
                                    displayEmpty
                                    label="Estado"
                                    name="estado">
                                    {(this.props.estados && this.props.estados.map) ?
                                        this.props.estados.map((x) => (<MenuItem value={x.id}>{x.name}</MenuItem>))
                                        : undefined}</TextField>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField InputProps={{ className: "inputProps_Usuario_NombreApellido" }} fullWidth label={"Nombre"}
                                    InputLabelProps={
                                        { style: { marginLeft: "10px" } }
                                    }
                                    onChange={this.props.handleOnChangeFiltro} name="nombre_apellido" value={this.props.nombre_apellido} id="usuario-label" />
                            </Grid>
                            {/*
                    <Grid item xs={12} sm={6}>
                    <TextField  fullWidth label={"Razon Social"} onChange={this.props.handleOnChangeFiltro} name="razon_social" value={ this.props.razon_social} id="usuario-label" />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                    <TextField label={"Localidad"} onChange={this.props.handleOnChangeFiltro} name="localidad" value={this.props.localidad} id="usuario-label" />
                    <Select style={{top:"16px"}} 
                    onChange={this.props.handleOnChangeFiltro}
            onClose={this.props.localidadClose}
            onOpen={this.props.localidadOpen}
                    open={this.props.localidadSuggest}
                    inputProps={{  name: 'localidad-select', id:"localidad-select"}}>
                        {this.props.localidades.map((x)=>(<MenuItem value={x}>{x}</MenuItem>))}
                    </Select>
                    </Grid>
                    
                    <Grid item xs={2}>
                    <Checkbox   style={{width:"90%"}} onChange={this.props.handleOnChangeFiltro} name="noHabilitados" checked={this.props.noHabilitados} id="usuario-label" />
                    </Grid>

                    <Grid item xs={10}>
                    <InputLabel style={{top:"12px", position:"relative"}} shrink htmlFor="usuario-label">Usuarios inhabilitados</InputLabel>
                    </Grid>
                    
                    <Grid item xs={2}>
                    <Checkbox   style={{width:"90%"}} onChange={this.props.handleOnChangeFiltro} name="noConfirmados" checked={this.props.noConfirmados} id="usuario-label" />
                    </Grid>
                    
                    <Grid item xs={10}>
                    <InputLabel style={{top:"12px", position:"relative"}} shrink htmlFor="usuario-label">Correos no confirmados</InputLabel>
                    </Grid>
                    */}

                            <Grid item xs={10} sm={6}>
                                <InputLabel class='inputLabel_ListaBlanca_ListaNegra' shrink htmlFor="usuario-label">En lista blanca</InputLabel>
                            </Grid>

                            <Grid item xs={10} sm={6}>
                                <InputLabel class='inputLabel_ListaBlanca_ListaNegra' shrink htmlFor="usuario-label">En lista negra</InputLabel>
                            </Grid>

                            <Grid xs={12} sm={6}>
                                <GreenSwitch onChange={this.props.handleOnChangeFiltro} name="listaBlanca" checked={this.props.listaBlanca} id="usuario-label" />
                            </Grid>

                            <Grid xs={12} sm={6}>
                                <GreenSwitch onChange={this.props.handleOnChangeFiltro} name="listaNegra" checked={this.props.listaNegra} id="usuario-label" />
                            </Grid>

                            <h2 className='lineaDivisionAbajo'></h2>

                        </Grid >

                        <div style={{ textAlign: "center", marginTop: "5px" }}>
                            <Button className="btnFlatBusquedaAvanzada" onClick={this.props.handleOnClickLimpiar} >Limpiar</Button>
                            <Button variant="contained" className="btnPrincipalBusquedaAvanzada" onClick={() => { this.props.handleOnSearch(this.props.nombre) }}>Buscar</Button>
                        </div>
                    </div>
                </Dialog>


                {/* MODAL CONFIRMACION DE PEDIDO */}
                <Dialog
                    classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootContent }}
                    open={this.props.openModalNotificaciones}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='sm'
                    fullWidth={true}
                >
                    <DialogContent classes={{ root: classes.rootContent }}>
                        <Row style={{ margin: '0px' }}>

                            <Col xs={12} md={12} lg={12} style={{ padding: '0px' }}>
                                <div className='containerModalNotificaciones'>

                                    <div className='containerTitle'>
                                        <div className='labelNotificaciones'>
                                            Notificaciones
                                        </div>
                                        <div style={{ display: 'flex' }}>
                                            <CloseIcon cursor='pointer' fontSize='medium' onClick={() => { this.props.handleOnClickNotificaciones(undefined) }} />
                                        </div>
                                    </div>

                                    {this.props.notificaciones && <div id='expandedNoti' className='containerNotificaciones'>
                                        {this.props.notificaciones.length > 0 && this.props.notificaciones.map((n) => {
                                            return <div style={{ width: '100%' }}>
                                                <ExpansionPanel>
                                                    <ExpansionPanelSummary
                                                        className='panelNoti'
                                                        expandIcon={<ExpandMoreIcon style={{ color: '#FFFFFF' }} />}
                                                        aria-controls={`panel${n.idNotificacion}a-content`}
                                                        id={`panel${n.idNotificacion}a-header`}
                                                    >
                                                        <div>
                                                            <div className='containerFechaInfo'>{n.fechaRegistro}</div>
                                                            <Typography className={`${classes.heading} labelNoti`}>{n.nota.slice(0, 30)}...</Typography>
                                                        </div>
                                                    </ExpansionPanelSummary>
                                                    <ExpansionPanelDetails style={{ padding: '0px' }}>
                                                        <div className='labelNotiCompleta'>
                                                            {n.nota}
                                                        </div>
                                                    </ExpansionPanelDetails>
                                                </ExpansionPanel>
                                            </div>
                                        })}
                                    </div>}

                                    {this.props.notificaciones && this.props.notificaciones.length === 0 &&
                                        <div className='labelNoNotificaciones'>No se encontraron categorías para mostrar</div>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
}

UsuarioListado.propTypes = {
    usuarios: PropTypes.object.isRequired,
    tiposUsuario: PropTypes.array,
    handleOnChangeFiltro: PropTypes.func,
    handleOnChange: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    handleOnSearch: PropTypes.func.isRequired,
    handleOnCloseConfirmacion: PropTypes.func,
    openModalNotificaciones: PropTypes.bool.isRequired,
    notificaciones: PropTypes.object,
    handleOnClickNotificaciones: PropTypes.func,
}

UsuarioListado.defaultProps = {
    catalogos: []
}

export default withStyles(styles)(UsuarioListado)